<template>
  <div>
    <i>Click on the map to set the location:</i><br />
    <div
        ref="googleMap"
        class="google-map mb-3"
        :style="styles"
    />
    <v-toolbar
        class="mb-3"
        flat
    >
      Latitude: {{ innerValue.length ? innerValue[0] : 'None' }}<br />
      Longitude: {{ innerValue.length ? innerValue[1] : 'None' }}<br />
      <v-spacer/>
      <v-btn
          :disabled="!marker"
          @click="deleteMarker"
      >Delete Marker</v-btn>
    </v-toolbar>
  </div>
</template>
<script>
/* eslint-disable no-undef */
export default {
  name: 'GoogleGeoPoint',
  props: {
    latitude: {
      type: Number,
      required: false,
    },
    longitude: {
      type: Number,
      required: false,
    },
    styles: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      map: null,
      marker: null,
    };
  },
  computed: {
    innerValue: {
      get() {
        if (this.latitude && this.longitude) {
          return [this.latitude, this.longitude];
        }
        return [];
      },
      set(val) {
        let latitude = null;
        let longitude = null;
        if (val && val[0] && val[1]) {
          [latitude, longitude] = val;
        }
        this.$emit('update:latitude', latitude);
        this.$emit('update:longitude', longitude);
      },
    },
  },
  watch: {
    latitude() {
      this.updateMarker();
    },
    longitude() {
      this.updateMarker();
    },
  },
  mounted() {
    this.initMap();
  },
  methods: {
    updateMarker() {
      let latLng = null;
      if (this.latitude && this.longitude) {
        latLng = new google.maps.LatLng(
          this.latitude,
          this.longitude,
        );
      }
      return this.setMarker(latLng);
    },
    deleteMarker() {
      this.innerValue = [];
    },
    center() {
      if (!this.map) {
        return;
      }
      this.map.setCenter(this.getCenterLatLng());
      this.map.setZoom(this.innerValue.length ? 15 : 10);
    },
    getCenterLatLng() {
      return new google.maps.LatLng(
        this.innerValue.length ? this.innerValue[0] : 34.052235,
        this.innerValue.length ? this.innerValue[1] : -118.243683,
      );
    },
    initMap() {
      this.map = new google.maps.Map(this.$refs.googleMap, {
        zoom: this.innerValue.length ? 15 : 10,
        center: this.getCenterLatLng(),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });

      const latLng = this.innerValue.length ? new google.maps.LatLng(
        this.innerValue[0],
        this.innerValue[1],
      ) : null;

      if (latLng) {
        this.setMarker(latLng);
      }

      google.maps.event.addListener(this.map, 'click', (event) => {
        this.innerValue = [
          Number((event.latLng.lat()).toFixed(6)),
          Number((event.latLng.lng()).toFixed(6)),
        ];
      });
    },
    setMarker(latLng) {
      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
      if (latLng) {
        this.marker = new google.maps.Marker({
          position: latLng,
          map: this.map,
        });
      }
    },
  },
};
</script>
